import * as _ from 'lodash';

export default function getImage({
	dish, images
}) {
	if (!_.isEmpty(dish)) {
		const img = images['dish-' + (dish.image) + '.jpg'];
		if (img !== undefined) {
			return img;
		} else {
			console.log('Image fehlt')
			console.log(dish)
			return images['catchAll.jpg'];
		}
	} else {
		return images['catchAll.jpg'];
	}
};


// WEBPACK FOOTER //
// ./src/assets/functions/getImage.js